import { render, staticRenderFns } from "./ModalBranchForm.vue?vue&type=template&id=245d9042&scoped=true&"
import script from "./ModalBranchForm.vue?vue&type=script&lang=js&"
export * from "./ModalBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalBranchForm.vue?vue&type=style&index=0&id=245d9042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d9042",
  null
  
)

export default component.exports